var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExceptionalPlace = function SvgExceptionalPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 22h35v35H22z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-6{fill:none;isolation:isolate;opacity:.5;stroke:#c8cee7;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0h50v60H10z",
    style: {
      fill: "#e9ecf5",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10h50v50H0z",
    style: {
      fill: "#e9ecf5",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1 22.9a.5.5 0 0 1 .5.5A15.6 15.6 0 0 0 54.2 39a.5.5 0 0 1 0 1 15.6 15.6 0 0 0-15.6 15.6.5.5 0 0 1-1 0A15.6 15.6 0 0 0 22 40a.5.5 0 0 1 0-1 15.6 15.6 0 0 0 15.6-15.6.5.5 0 0 1 .5-.5m0 4.54A16.58 16.58 0 0 1 26 39.5a16.58 16.58 0 0 1 12.1 12.06A16.58 16.58 0 0 1 50.16 39.5 16.58 16.58 0 0 1 38.1 27.44",
    style: {
      fill: "#a5aed6",
      fillRule: "evenodd"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 30a4.61 4.61 0 0 0 4.6 4.6 4.61 4.61 0 0 0-4.6 4.6A4.61 4.61 0 0 0 5 34.6 4.61 4.61 0 0 0 9.6 30M18.5 15a6.49 6.49 0 0 0 6.5 6.5 6.49 6.49 0 0 0-6.5 6.5 6.49 6.49 0 0 0-6.5-6.5 6.49 6.49 0 0 0 6.5-6.5",
    className: "cls-6"
  })))));
};
export default SvgExceptionalPlace;